module.exports = __webpack_public_path__ + "img/canaryislands.ff66c20a.svg";